import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import React from 'react';
import { languages } from '../../common/constants/languages';
import language from '../../common/language/language';
import c_hall_logo from '../../media/chall-logo-big.png';
import c_hall_logo_mobile from '../../media/logo-chall-movil.png';
import cosentino_logo from '../../media/cosentino-logo.png';
import cosentino_logo_mobile from '../../media/logo-cosentino-movil.png';
import product_logo_mobile from '../../media/Logo_Dtt.png';
import product_logo from '../../media/logo-dtt-big.png';
import './Language.scss';

export class Language extends React.Component<any, any> {
  render() {
    return (
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}>
        <div className='language'>
          <div className='header-container'>
            <img className='logo__cosentino desktop' src={cosentino_logo} alt="Cosentino Logo" />
            <img className='logo__cosentino mobile' src={cosentino_logo_mobile} alt="Cosentino Logo" />
          </div>
          <img className='logo__c-next desktop' src={c_hall_logo} alt="C-Hall Logo" />
          <img className='logo__c-next mobile' src={c_hall_logo_mobile} alt="C-Hall Logo" />
          <div className='text-container'>
            <div>{language.chall.selectLanguage.en}</div>
            <div>{language.chall.selectLanguage.es}</div>
          </div>
          <div className='buttons-container'>
            <div className='button-container'>
              <button onClick={() => this.goToWelcome(languages.es)}>ESP</button>
            </div>
            <div className='button-container'>
              <button onClick={() => this.goToWelcome(languages.en)}>ENG</button>
            </div>
          </div>
          {/* <div className='text_slogan mobile'>{language.chall.welcome.product_text}</div> */}
          <div className='text_slogan mobile'>
            DESIGN LIVES<br />IN EVERY DETAIL
          </div>
          <div className='text_slogan desktop'>{language.chall.welcome.product_text}</div>
          <img className='logo__product desktop' src={product_logo} alt="DESIGN TO TRANSFORM"/>
          <img className='logo__product mobile' src={product_logo_mobile} alt="DESIGN TO TRANSFORM"/>
        </div>
      </MsalAuthenticationTemplate>
    );
  }

  goToWelcome = async (language: string) => {
    this.props.history.push(`/welcome/${language}`);
  }
}